import { TableCustom } from '../../../../../../component/table/table-custom/TableCustom';
import { MEDICAL_HISTORY_COLUMNS } from '../Columns';

const MedicalHistory = ({ data }: { data: any[] }) => {
	return <TableCustom data={data} columns={MEDICAL_HISTORY_COLUMNS} maxHeight={200} />;
};

export default MedicalHistory;
